import { ApplicationRef, DoBootstrap, NgModule, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, APP_INITIALIZER, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';

import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatTabsModule } from '@angular/material/tabs';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { NewsComponent } from './news/news.component';
import { appConfig } from './app.config';
import { routes } from './app.routes';
import { ThemeService } from './services/theme.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { AuthInterceptor } from './auth.interceptor';
import { AppMobileComponent } from './app.mobile.component';
import { PartnersComponent } from './partners/partners.component';
import { CommonModule, DatePipe } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { OverlayModule } from '@angular/cdk/overlay';
import { RegisterComponent } from './user/register/register.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { LoginComponent } from './user/login/login.component';
import { DashboardComponent } from './user/dashboard/dashboard.component';
import { DataComponent } from './user/data/data.component';
import { Page404Component } from './general/page404/page404.component';
import { HomeComponent } from './home/home.component';
import { ContactComponent } from './contact/contact.component';
import { BasicDataComponent } from './user/basic-data/basic-data.component';
import { FilesComponent } from './user/files/files.component';
import { SharedModule } from './shared/shared.module';
import { LoaderService } from './services/loader.service';
import { LoaderInterceptor } from './services/loader.interceptor';
import { ErrorLoggingInterceptor } from './services/error-logging.interceptor';
import { GlobalErrorHandler } from './services/global-error.handler';
import { LoaderComponent } from './shared/loader.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { UploadFileComponent } from './user/upload-file/upload-file.component';
import { CardsComponent } from './admin/cards/cards.component';
import { ListCardsComponent } from './user/cards/cards.component';
import { FamilyComponent } from './user/family/family.component';
import { OfferComponent } from './offer/offer.component';
import { OfferMenuComponent } from './offer/offer-menu/offer-menu.component';
import { OfferListComponent } from './offer/offer-list/offer-list.component';
import { OfferViewComponent } from './offer/offer-view/offer-view.component';
import { OfferImageComponent } from './offer/offer-image/offer-image.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { GoogleMapsModule } from '@angular/google-maps';
import { OfferDetailsComponent } from './offer/offer-details/offer-details.component';
import { PartnerspartnerViewComponent } from './partners/partnerspartner-view/partnerspartner-view.component';

import { NewsListItemComponent } from './news/news-list-item/news-list-item.component';
import { NewsDetailComponent } from './news/news-detail/news-detail.component';
import { PasswordReminderComponent } from './user/password-reminder/password-reminder.component';
import { ReplacePipe } from './pipes/replace.pipe';
import { CardComponent } from './user/card/card.component';
import { QrCodeComponent } from 'ng-qrcode';
import { RemindPasswordComponent } from './user/remind-password/remind-password.component';
import { ConfirmEmailComponent } from './user/confirm-email/confirm-email.component';
import { PartnerspartnerDetailsComponent } from './partners/partnerspartner-details/partnerspartner-details.component';
import { environment } from '../environments/environment';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { SearchComponent } from './search/search.component';
import { ItemSearchComponent } from './search/item/item.component';
import { MatCardModule } from '@angular/material/card';
import { PageComponent } from './page/page.component';
import { MapComponent } from './map/map.component';
import { MessageInfoComponent } from './user/cards/create-message-info/create-message-info.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTableModule } from '@angular/material/table';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDividerModule } from '@angular/material/divider';
import { MatPaginatorModule } from '@angular/material/paginator';
import { PersonsTableComponent } from './user/persons-table/persons-table.component';
import { PersonEditDataComponent } from './user/person-edit-data/person-edit-data.component';
import { ParnterEditComponent } from './user/parnter-edit/parnter-edit.component';
import { HtmlEditorComponent } from './shared/html-editor/html-editor.component';
import { ParnterOfferEditComponent } from './user/parnter-offer-edit/parnter-offer-edit.component';
import { SplashScreenComponent } from './splash-screen/splash-screen.component';
import { AppInfoDialogComponent } from './shared/app-info-dialog/app-info-dialog.component';
import { RodoComponent } from './user/rodo/rodo.component';
import { LoggerService } from './services/logger.service';
import { FirebaseMessagingService } from './services/firebase-messaging.service';
import { PartnerScannerComponent } from './user/partner-scan/partner-scan.component';
import { PwaService } from './services/pwa.service';
import { CamapignComponent } from './campaigns/camapign/camapign.component';
import { CamapignsComponent } from './campaigns/camapigns/camapigns.component';
import { CampaignScansComponent } from './campaigns/campaign-scans/campaign-scans.component';
import { PartnerProductsComponent, PartnerProductDialogComponent } from './campaigns/partner-products/partner-products.component';
import { AwardsComponent } from './page/awards/awards.component';
import { CamelCaseAutoFormatDirective } from './directives/camel-case-auto-format.directive';
import { CheckStreetNameDirective } from './directives/check-street-name.directive';
import { PwaComponent } from './pwa/pwa.component';
import { PwaInstallerComponent } from './shared/pwa-installer/pwa-installer.component';
import { PwaInstallComponent } from './shared/pwa-install/pwa-install.component';
import { BeAPartnerComponent } from './page/be-a-partner/be-a-partner.component';
import { CreateCardComponent } from './page/create-card/create-card.component';
import { InstallMobileAppComponent } from './page/install-mobile-app/install-mobile-app.component';
import { MatNativeDateModule  } from '@angular/material/core';
import { MatMomentDateModule, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { registerLocaleData } from '@angular/common';
import localePl from '@angular/common/locales/pl';

import moment from 'moment';

// Helper function to detect mobile devices
export function isMobile(): boolean {
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
}

registerLocaleData(localePl);

// Set moment.js to use Polish locale globally
moment.locale('pl-PL');
moment.locale('pl');
moment.locale('PL');

export const CUSTOM_DATE_FORMATS = {
  parse: {
    dateInput: 'YYYY-MM-DD',
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD.MM.YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@NgModule({
  imports: [
    MatCardModule,
    SharedModule,
    CarouselModule,
    QrCodeComponent,
    ReplacePipe,
    DatePipe,
    GoogleMapsModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    FormsModule,
    MatMenuModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatTableModule,
    MatDialogModule,
    MatSelectModule,
    MatSnackBarModule,
    MatDividerModule,
    MatPaginatorModule,
    MatDatepickerModule,
    MatToolbarModule,
    MatSidenavModule,
    MatIconModule,
    CommonModule,
    MatListModule,
    MatButtonModule,
    MatBottomSheetModule,
    MatTabsModule,
    BrowserModule,
    MatMomentDateModule,
    HtmlEditorComponent,
    AppInfoDialogComponent,
    CamelCaseAutoFormatDirective,
    CheckStreetNameDirective,
    MatAutocompleteModule,
    OverlayModule,
    RouterModule.forRoot(routes),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000'
    }),
    HttpClientModule
],

  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    {
      provide: APP_INITIALIZER,
      useFactory: (loggerService: LoggerService) => () => loggerService.loadConfig(),
      deps: [LoggerService],
      multi: true,
    },
    /*
    {
      provide: APP_INITIALIZER,
      useFactory: (messagingService: FirebaseMessagingService, pwaService: PwaService) => () => {
        // Initialize FCM after app loads
        //pwaService.isPwaInstalled();
        console.log('Platform from localStorage:', localStorage.getItem('platform')); 
        //do not register firebase when running as platform = web (info in localstorage as localStorage.getItem('platform'))
        if (localStorage.getItem('platform') === 'web') {
          messagingService.requestPermission();
          messagingService.listenForMessages();
        }
      },
      deps: [FirebaseMessagingService, PwaService],
      multi: true,
    },
    */
    { provide: LOCALE_ID, useValue: 'pl-PL' }, // Set application locale to Polish
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS }, // Set custom date formats globally
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    ThemeService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorLoggingInterceptor,
      multi: true,
    },
    ...appConfig.providers,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    FamilyComponent,
    SplashScreenComponent,
    ListCardsComponent,
    LoginComponent,
    ParnterOfferEditComponent,
    ParnterEditComponent,
    BeAPartnerComponent,
    CreateCardComponent,
    DashboardComponent,
    AppMobileComponent,
    AppComponent,
    PartnersComponent,
    RegisterComponent,
    BasicDataComponent,
    FilesComponent,
    NewsComponent,
    UploadFileComponent,
    RodoComponent,
    DataComponent,
    HomeComponent,
    PartnerScannerComponent,
    ContactComponent,
    Page404Component,
    OfferComponent,
    PartnerProductsComponent,
    PartnerProductDialogComponent,
    OfferMenuComponent,
    OfferListComponent,
    OfferViewComponent,
    OfferImageComponent,
    OfferDetailsComponent,
    PartnerspartnerViewComponent,
    PartnerspartnerDetailsComponent,
    NewsListItemComponent,
    NewsDetailComponent,
    PasswordReminderComponent,
    RemindPasswordComponent,
    ConfirmEmailComponent,
    CardComponent,
    PageComponent,
    SearchComponent,
    ItemSearchComponent,
    MapComponent,
    InstallMobileAppComponent,
    MessageInfoComponent,
    PersonsTableComponent,
    PersonEditDataComponent,
    CamapignComponent,
    CampaignScansComponent,
    AwardsComponent,
    CamapignsComponent,
    PwaComponent,
    PwaInstallComponent,
    PwaInstallerComponent
  ],
  bootstrap: [], // Bootstrap dynamically in main.ts
})
export class AppModule implements DoBootstrap {
  constructor(private pwaService: PwaService) {}

  ngDoBootstrap(appRef: ApplicationRef) {
    // Safari safeguard: prevent multiple bootstrap attempts
    if ((window as any).__appBootstrapped) {
      console.warn('App already bootstrapped, skipping to prevent loop');
      return;
    }
    (window as any).__appBootstrapped = true;

    const isAdmin = window.location.pathname.startsWith('/admin');
    const bootstrapBasedOnState = () => {
      const isInstalledPwa = this.pwaService.isPwaInstalled();

      if (isInstalledPwa && !isAdmin) {
        appRef.bootstrap(AppMobileComponent);
      } else {
        appRef.bootstrap(AppComponent); // Or some other component
      }
    };

    const isInitiallyInstalled = this.pwaService.isPwaInstalled();
    if (isInitiallyInstalled) {
      bootstrapBasedOnState();
      return;
    }

    setTimeout(() => {
      bootstrapBasedOnState();
    }, 450);
  }
}